export const PAGE_NAMES = {
  homepage: '/',
  movies: '/movies',
  movieId: '/movies/:movieId',
  movieCast: '/movies/:movieId/cast',
  movieReviews: '/movies/:movieId/reviews',
};
